import { render, staticRenderFns } from "./RegisterVehicles.vue?vue&type=template&id=5636caba&scoped=true&"
import script from "./RegisterVehicles.vue?vue&type=script&lang=js&"
export * from "./RegisterVehicles.vue?vue&type=script&lang=js&"
import style0 from "./RegisterVehicles.vue?vue&type=style&index=0&id=5636caba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636caba",
  null
  
)

export default component.exports